"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
require("./MaterialIconStyle.scss");
var MaterialIcon = function (_a) {
    var iconName = _a.iconName;
    return ((0, jsx_runtime_1.jsx)("span", __assign({ className: 'material-icons' }, { children: iconName })));
};
exports.default = MaterialIcon;
